/**
 * Strip the per-turn context wrapper that the chat handlers used to embed
 * inside the user message before persisting it. New messages are stored
 * unwrapped (the wrapper now lives in a non-cached system block), but
 * pre-existing threads still contain the old format and would otherwise
 * render the slide JSX or slide-id index back to the user.
 */
export function unwrapLegacyUserText(text: string): string {
  // The typeof guard is unreachable per the signature and stays anyway: this
  // reads a thread persisted on disk, which can hold anything an older format
  // wrote, and returning it untouched is better than throwing inside a render.
  if (typeof text !== 'string' || !text) return text;

  // Slide-chat legacy: "Peer slides for context:\n…\n\nCurrent slide (id):\n```jsx\n<source>\n```\n\n<prompt>"
  if (/Current slide \(/.test(text) && text.includes('```')) {
    const lastFence = text.lastIndexOf('```');
    if (lastFence !== -1) {
      const after = text.slice(lastFence + 3).replace(/^\n+/, '');
      if (after.trim()) return after;
    }
  }

  // Deck-chat legacy: "User request: <prompt>\n\nSlide ids (use these verbatim in tool calls):\n…"
  if (text.startsWith('User request: ')) {
    const rest = text.slice('User request: '.length);
    const cut = rest.indexOf('\n\nSlide ids (');
    return cut === -1 ? rest : rest.slice(0, cut);
  }

  return text;
}
